'use strict';

import { isAprimo, attachAprimoVideo } from './aprimo-video.js';

jQuery(function($) {

    /**
     * Cart and Checkout Manager
     * Handles cart updates, quantity changes, guest checkout, and cross-sell slider.
     */
    class Cart_Checkout_Manager {

        /**
         * Constructor.
         */
        constructor() {
            // Debounced version of triggerUpdateCart
            this.validateCheckoutFields();
            this.eventHandlers();
            this.injectCartLoader();
            // Check shipping method on page load
            $(document).ready(() => {
                this.handleShippingMethodChange();
                this.initSessionStorage();
				this.greetingCardCheck();
            });
        }

        /**
         * Inject cart loader element into the page.
         */
        injectCartLoader() {
            if ($('body.woocommerce-cart').length && !$('#pandora-cart-loader').length) {
                const loaderUrl = typeof mpParams !== 'undefined' && mpParams.loaderGifUrl
                    ? mpParams.loaderGifUrl
                    : '';
                if (loaderUrl) {
                    $('body.woocommerce-cart').append(
                        '<div id="pandora-cart-loader" class="pandora-cart-page-loader">' +
                            '<img src="' + loaderUrl + '" alt="Loading..." class="pandora-loader-img" />' +
                        '</div>'
                    );
                }
            }
        }

        /**
         * Bind click events for quantity increase and decrease buttons.
         */
        eventHandlers() {
            $(document.body).on('click', 'a.qty-btn.qty-plus', this.increaseQuantity.bind(this));
            $(document.body).on('click', 'a.qty-btn.qty-minus', this.decreaseQuantity.bind(this));
            $(document.body).on('click', '.woocommerce-cart-form a.link-remove', this.removeCartItem.bind(this));
            $(document.body).on('change keyup', '#account_password', this.changeAccountPassword.bind(this));
            $(document.body).on('click', '.guest-checkout', this.guestCheckout.bind(this));
            $(document.body).on('click', '#triggerCoupon_2', this.triggerCouponActionPandora.bind(this));
            $(document.body).on('keydown', '#coupon_code, input.couponCode', this.handleCouponInputKeydown.bind(this));
            $(document.body).on('click', '.matat-remove-coupon', this.removeCouponPandora.bind(this));

            $(document.body).on('updated_checkout', this.updateCheckout.bind(this));
            $(document.body).on('updated_checkout', this.reapplySameDayValidation.bind(this));
            $(document.body).ready( this.sliderCrossSell(), this.initVideoControls() );
            $(document.body).on( 'keyup', 'textarea#greeting_text', this.greetingTextCount.bind(this) );
            $(document.body).on( 'click', '#greetingcard-check', this.greetingCardCheck.bind(this) );

            // Use 'input' as primary event - works reliably on iOS Safari/GSA for emoji detection
            $(document.body).on('input', 'textarea.greeting_text', this.greetingTextEscChar.bind(this));
            $(document.body).on('paste', 'textarea.greeting_text', this.greetingTextEscCharPaste.bind(this));
            // Also handle blur to catch any missed input on iOS
            $(document.body).on('blur', 'textarea.greeting_text', this.greetingTextEscChar.bind(this));

            $(document).on('click', '#place_order', this.submitCheckoutForm.bind(this));

            // Handle shipping method change for Local Pickup
            $(document.body).on('change', 'input[name^="shipping_method"]', this.handleShippingMethodChange.bind(this));
            $(document.body).on('updated_checkout', this.handleShippingMethodChange.bind(this));

            // Handle sessionStorage for form data persistence
            $(document.body).on('input change', 'input, select, textarea', this.saveFormDataToSessionStorage.bind(this));
        }

        /**
         * Handle guest checkout.
         */
        guestCheckout(e) {
            e.preventDefault();
            var __this = $(e.currentTarget);

            __this.parents(".myuser-wrapper").addClass("d-none");
            jQuery('.checkout-main-wrap').removeClass("not_logged_in");
            jQuery('#info_link').removeClass('current').addClass('go_back');
            jQuery('#shipping_link').addClass('current');

            const href = __this.attr('data-href');
            if (href) {
                history.pushState(null, '', href);
            }
        }

        /**
         * Change account password.
         */
        changeAccountPassword(e) {
            e.preventDefault();
            var __this = this;
            jQuery('input[name=createaccount]').val( __this.val().length ? '1' : '0');
        }

        /**
         * Handle keydown on coupon input field.
         * Prevents form submission on Enter and triggers coupon button click instead.
         */
        handleCouponInputKeydown(e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                e.preventDefault();
                e.stopPropagation();

                // Find and click the coupon button
                const $input = $(e.currentTarget);
                const $button = $input.closest('.input-wrap').find('#triggerCoupon_2, .btn-apply-coupon');

                if ($button.length) {
                    $button.trigger('click');
                }
            }
        }

        /**
         * Coupon update handler.
         */
        async triggerCouponActionPandora(e) {
            e.preventDefault();

            var $button = $(e.currentTarget);
            var couponCode = $button.closest('.input-wrap').find('input[name="coupon_code"]').val();

            // Fallback for mobile view
            if (!couponCode) {
                couponCode = $('.coupon-box.mobile input[name="coupon_code"]').val();
            }

            if (!couponCode) {
                $('.coupon-message').html('אנא הזן קוד קופון').slideDown();
                return;
            }

            $('.coupon-message').html('אנא המתן...').slideDown();
            $('.coupon-message-results').html('');

            try {
                // First check if this is a giftcard
                const giftcardResponse = await this.checkGiftcard(couponCode);

                if (giftcardResponse.success) {
                    apply_giftcard_balance(couponCode, giftcardResponse.data.giftcard_balance);
                    return;
                }

                // Check if it's a nayax coupon
				if (couponCode.length === 11) {
					couponCode = '0' + couponCode;
				}

				if (couponCode.length === 12) {
					const nayaxResponse = await this.checkNayaxCoupon(couponCode);

					if (nayaxResponse.success) {
						$('body').trigger('applied_coupon_in_checkout', [couponCode, nayaxResponse]);
						$('.coupon-message-results').html(nayaxResponse.data.message).slideDown();
						$('body').trigger('update_checkout');
					} else {
						// Show error message from response (no need for update_checkout)
						const errorMsg = nayaxResponse.data?.message || 'קוד הקופון אינו תקין';
						$('.coupon-message-results').html(`<div class="woocommerce-error">${errorMsg}</div>`).slideDown();
					}
				} else {
					// Not a giftcard or nayax coupon, apply as woocommerce coupon
					await this.applyCoupon(couponCode);
				}
            } catch (error) {
                $('.coupon-message-results').html('<div class="woocommerce-error">שגיאה בעת החלת הקופון.</div>').slideDown();
            } finally {
                $('.coupon-message').slideUp();
            }

            return false;
        }

        /**
         * Check if code is a giftcard.
         */
        checkGiftcard(couponCode) {
            return new Promise((resolve, reject) => {
                if (typeof wc_checkout_params === 'undefined') {
                    reject('wc_checkout_params not available');
                    return;
                }
                $.ajax({
                    url: wc_checkout_params.ajax_url,
                    type: 'POST',
                    data: {
                        action: 'pandora-check-giftcard',
                        code: couponCode
                    },
                    success: resolve,
                    error: reject
                });
            });
        }

        /**
         * Check if code is a nayax coupon.
         */
        checkNayaxCoupon(couponCode) {
            return new Promise((resolve, reject) => {
                if (typeof wc_checkout_params === 'undefined') {
                    reject('wc_checkout_params not available');
                    return;
                }
                $.ajax({
                    url: wc_checkout_params.ajax_url,
                    type: 'POST',
                    data: {
                        action: 'pandora-check-nayax-coupon',
                        code: couponCode
                    },
                    success: resolve,
                    error: reject
                });
            });
        }

        /**
         * Apply coupon code.
         */
        applyCoupon(couponCode) {
            return new Promise((resolve, reject) => {
                if (typeof wc_checkout_params === 'undefined') {
                    reject('wc_checkout_params not available');
                    return;
                }
                $.ajax({
                    url: wc_checkout_params.wc_ajax_url.toString().replace('%%endpoint%%', 'apply_coupon'),
                    type: 'POST',
                    data: {
                        coupon_code: couponCode,
                        security: wc_checkout_params.apply_coupon_nonce,
                        woocommerce_apply_coupon: 1
                    },
                    success: function(response) {
                        if (response) {
                            $('.coupon-message-results').html(response).slideDown();
                            $('body').trigger('applied_coupon_in_checkout', [couponCode, response]);
                        }
                        $('body').trigger('update_checkout');
                        resolve(response);
                    },
                    error: reject
                });
            });
        }

        /**
         * Remove coupon handler.
         */
        removeCouponPandora(e) {
            e.preventDefault();

            var $button = $(e.currentTarget);
            var couponCode = $button.data('coupon');

            if (!couponCode) {
                $('.coupon-message-results').html('<div class="woocommerce-error">קוד קופון לא נמצא.</div>').slideDown();
                return;
            }

            $('.coupon-message').html('מסיר את הקופון...').slideDown();
            $('.coupon-message-results').html('');

            if (typeof wc_checkout_params === 'undefined') {
                $('.coupon-message-results').html('<div class="woocommerce-error">שגיאה בהסרת הקופון.</div>').slideDown();
                return;
            }

            $.ajax({
                url: wc_checkout_params.wc_ajax_url.toString().replace('%%endpoint%%', 'remove_coupon'),
                type: 'POST',
                data: {
                    coupon: couponCode,
                    security: wc_checkout_params.remove_coupon_nonce
                },
                success: function(response) {
                    if (response && response.messages) {
                        $('.coupon-message-results').html(response.messages).slideDown();
                        $('body').trigger('removed_coupon_in_checkout', [couponCode, response]);
                    }

                    $('body').trigger('update_checkout');
                    $('body').trigger('wc_fragment_refresh');
                },
                error: function() {
                    $('.coupon-message-results').html('<div class="woocommerce-error">שגיאה בעת הסרת הקופון.</div>').slideDown();
                },
                complete: function() {
                    $('.coupon-message').slideUp();
                }
            });

            return false;
        }



        /**
         * Update checkout when cart is updated.
         */
        updateCheckout(e, data) {
            e.preventDefault();
            var __this = $(e.currentTarget);

            // Trigger the update cart function
            $('p#shipping_postcode_field').hide();
            $('input[type="radio"]').each(function () {
                if ( __this.is(':checked') && ( __this.val().indexOf('flat_rate:3') !== -1)) {
                    $('p#shipping_postcode_field').show().addClass('validate-required');
                } else {
                }
            });
            $('p#shipping_city_gett_field').hide();
            $('input[type="radio"]').each(function () {
                if ( __this.is(':checked') &&
                    (( __this.val().indexOf('flat_rate:7') !== -1) || ( __this.val().indexOf('free_shipping:8') !== -1))) {
                    $('p#shipping_city_gett_field').show();
                    $('p#shipping_city_field').hide();
                    $('input#shipping_city').val($('select#shipping_city_gett option:selected').text());
                    $('select#shipping_city_gett').change(function() {
                       $('input#shipping_city').val($('select#shipping_city_gett option:selected').text());
                    });
                }
            });

            this.initVideoControls();
        }

        /**
         * Show cart page loader (only if mini cart is not open)
         */
        showCartLoader() {
            if (!$('body').hasClass('is-mini-cart-open')) {
                $('body.woocommerce-cart').addClass('show-cart-loader');
            }
        }

        /**
         * Hide cart page loader
         */
        hideCartLoader() {
            $('body.woocommerce-cart').removeClass('show-cart-loader');
        }

        /**
         * Increase quantity
         */
        increaseQuantity(e) {
            e.preventDefault();

            const $btn = $(e.currentTarget);
            const $quantityInput = $btn.siblings('input.quantityHidden');
            const inputName = $quantityInput.attr('name');
            const step = Number($quantityInput.attr('step')) || 1;
            const max = Number($quantityInput.attr('max')) || 1000;

            let newValue = parseInt($quantityInput.val()) + step;

            if (max && newValue > max) {
                newValue = max;
            }

            $(document.body).find(`input[name="${inputName}"]`).val(newValue);

            // Show loader
            this.showCartLoader();
        }

        /**
         * Decrease quantity
         */
        decreaseQuantity(e) {
            e.preventDefault();

            const $btn           = $(e.currentTarget);
            const $quantityInput = $btn.siblings( 'input.quantityHidden' );
            const inputName      = $quantityInput.attr('name');
            const step           = Number($quantityInput.attr('step')) || 1;
            const min            = Number($quantityInput.attr('min')) || 1;

            let newValue = parseInt($quantityInput.val()) - step;
            if (newValue < min) {
                newValue = min;
            }
            $(document.body).find(`input[name="${inputName}"]`).val(newValue);

            // Show loader
            this.showCartLoader();
        }

        /**
         * Remove cart item - show loader before navigation
         */
        removeCartItem() {
            this.showCartLoader();
        }

        /**
         * Slider for cross-sell products
         */
        sliderCrossSell() {
            if(jQuery('.cross-sell-slider').length > 0) {
                new Swiper('.cross-sell-slider', {
                    slidesPerView: 4,
                    spaceBetween: 20,
                    loop: true,
                    breakpoints: {
                        320: {
                            slidesPerView: 1,
                            spaceBetween: 10,
                        },
                        480: {
                            slidesPerView: 2,
                        },
                        768: {
                            slidesPerView: 3,
                        },
                        1024: {
                            slidesPerView: 4,
                        },
                        1366: {
                            slidesPerView: 6,
                        }
                    }
                });
            }
        }

        /**
		 * Initialize video controls for product gallery.
		 */
		initVideoControls() {
			const $videos = $( ".shop_table").find('video');

			$videos.each(function () {
				const $video = $(this);
				const videoEl = this; // DOM element
				const videoUrl = $video.data('video-url');

				if (!videoUrl) return;

				// Aprimo MP4 / HLS. Cloudflare continues to the hls.js code below.
				if (isAprimo(videoUrl)) {
					attachAprimoVideo(videoEl, videoUrl, {
						onReady: () => videoEl.play().catch(err => console.warn('Video play prevented:', err))
					});
					return;
				}

				if (Hls.isSupported()) {
					const hls = new Hls({
						enableWorker: true,
						lowLatencyMode: true,
						backBufferLength: 90
					});

					hls.loadSource(videoUrl);
					hls.attachMedia(videoEl);

					hls.on(Hls.Events.MANIFEST_PARSED, function () {
						videoEl.muted = true;
						videoEl.loop = true;
						videoEl.playsInline = true;
						videoEl.play();
					});

					hls.on(Hls.Events.ERROR, function (event, data) {
						if (data.fatal) {
							switch (data.type) {
								case Hls.ErrorTypes.NETWORK_ERROR:
									console.error('Network error:', data);
									hls.startLoad();
									break;
								case Hls.ErrorTypes.MEDIA_ERROR:
									console.error('Media error:', data);
									hls.recoverMediaError();
									break;
								default:
									console.error('Fatal error:', data);
									hls.destroy();
									break;
							}
						}
					});
				} else if (videoEl.canPlayType('application/vnd.apple.mpegurl')) {
					// Native HLS support (Safari)
					videoEl.src = videoUrl;
					videoEl.addEventListener('loadedmetadata', function () {
						videoEl.muted = true;
						videoEl.loop = true;
						videoEl.playsInline = true;
						videoEl.play();
					});
				}
			});
		}

        /**
         * Submit checkout form
         */
        submitCheckoutForm(e) {
            e.preventDefault();

            // Check if jQuery Validate is available
            if (typeof $.fn.validate !== 'function') {
                $("#checkout").submit();
                return;
            }

            if ($("#checkout").valid()) {
                $("#checkout").submit();
            }
        }

        /**
         * Validate checkout form fields
         */
        validateCheckoutFields(){
            // Skip if checkout form doesn't exist or jQuery Validate not loaded
            if (!$('#checkout').length || typeof $.fn.validate !== 'function') {
                return;
            }

            // Custom validation method for same day delivery city
            if ($.validator && !$.validator.methods.sameDayCityRequired) {
                $.validator.addMethod("sameDayCityRequired", function(value, element) {
                    var hiddenCityValue = $('#same_day_delivery_city').val();
                    return hiddenCityValue && hiddenCityValue.trim() !== '';
                }, "יש לבחור עיר מהרשימה");
            }

            // Custom validation method: at least one alphanumeric character (English, Hebrew, or digit)
            if ($.validator && !$.validator.methods.hasAlphanumeric) {
                $.validator.addMethod("hasAlphanumeric", function(value, element) {
                    if (!$.validator.methods.required.call(this, value, element)) {
                        return true; // skip if field is empty and not required
                    }
                    return /[a-zA-Z0-9\u0590-\u05FF]/.test(value);
                }, "יש להזין אותיות ומספרים בלבד");
            }

            $("#checkout").validate({// initialize plugin on the form
				ignore: ":hidden",
				rules: {
					billing_first_name: {
						required: true,
						minlength: 2
					},
					billing_last_name: {
						required: true,
						minlength: 2,
					},
					billing_phone: {
						required: true,
						number: true,
						minlength: 10,
						maxlength: 10,
					},
					billing_address_1: {
						required: true,
						hasAlphanumeric: true,
					},
					billing_email: {
						required: true,
					},
					billing_city: {
						required: {
							depends: function (element) {
								const selectedShippingMethod = $('input[name^="shipping_method"]:checked').val();
								const isLocalPickup = selectedShippingMethod && selectedShippingMethod.includes('local_pickup');
								return !isLocalPickup && (!$('#billing_city_field').hasClass('d-none'));
							}
						},
						hasAlphanumeric: true,
					},
					same_day_delivery_city_input: {
						sameDayCityRequired: {
							depends: function (element) {
								var selectedMethod = $('input[name^="shipping_method"]:checked').val();
								return selectedMethod && selectedMethod.indexOf('same_day_delivery') !== -1;
							}
						}
					},
					pickup_location: {
						required: {
							depends: function (element) {
								return ($('.pickup_location').length > 0)
							}
						}
					},
					billing_house_number: {
						required: {
							depends: function (element) {
								const selectedShippingMethod = $('input[name^="shipping_method"]:checked').val();
								const isLocalPickup = selectedShippingMethod && selectedShippingMethod.includes('local_pickup');
								return !isLocalPickup;
							}
						},
						hasAlphanumeric: true,
					},
					billing_street: {
						required: {
							depends: function (element) {
								const selectedShippingMethod = $('input[name^="shipping_method"]:checked').val();
								const isLocalPickup = selectedShippingMethod && selectedShippingMethod.includes('local_pickup');
								return !isLocalPickup;
							}
						},
						hasAlphanumeric: true,
					},
					terms: {
						required: true,
					},
					shipping_first_name: {
						required: true,
						minlength: 2
					},
					shipping_last_name: {
						required: true,
						minlength: 2,
					},
					shipping_phone: {
						required: true,
						number: true,
						minlength: 10,
						maxlength: 10,
					},
					shipping_email: {
						required: true,
					},
					shipping_city: {
						required: true,
						hasAlphanumeric: true,
					},
					shipping_address_1: {
						required: true,
						hasAlphanumeric: true,
					},
					shipping_house_number: {
						required: true,
						hasAlphanumeric: true,
					},
					shipping_street: {
						required: true,
						hasAlphanumeric: true,
					},
				},
				messages: {
					billing_first_name: {
						required: "נדרש שם פרטי לחיוב.",
						minlength: "אורך השם הפרטי לחיוב צריך להיות מעל 2 ומתחת ל-10"
					},
					billing_last_name: {
						required: "נדרש שם משפחה לחיוב.",
						minlength: "אורך שם המשפחה לחיוב צריך להיות מעל 2 ומתחת ל-10"
					},
					billing_phone: {
						required: "נדרש מספר טלפון.",
						number: "הטלפון לחיוב צריך להיות מספר.",
						minlength: "מספר טלפון קצר מדי"
					},
					billing_email: {
						required: "כתובת דוא\"ל לא תקינה"
					},
					billing_address_1: {
						required: "נדרשת כתובת לחיוב.",
						hasAlphanumeric: "יש להזין אותיות ומספרים בלבד.",
					},
                    billing_city: {
                        required: "נדרשת עיר משלוח.",
                        hasAlphanumeric: "יש להזין אותיות ומספרים בלבד.",
                    },
                    same_day_delivery_city_input: {
                        sameDayCityRequired: "יש לבחור עיר מהרשימה"
                    },
                    shipping_phone: {
                        required: "נדרש מספר טלפון.",
                        number: "טלפון המשלוח חייב להיות מספר טלפון.",
						minlength: "מספר טלפון קצר מדי"
                    },
                    shipping_first_name: {
                        required: "השדה הזה הינו שדה חובה"
                    },
                    shipping_last_name: {
                        required: "השדה הזה הינו שדה חובה"
                    },
                    shipping_address_1: {
                        required: "נדרשת כתובת לחיוב.",
                        hasAlphanumeric: "יש להזין אותיות ומספרים בלבד.",
                    },
                    shipping_city: {
                        required: "נדרשת עיר משלוח.",
                        hasAlphanumeric: "יש להזין אותיות ומספרים בלבד.",
                    },
                    shipping_house_number: {
                        required: "השדה הזה הינו שדה חובה",
                        hasAlphanumeric: "יש להזין אותיות ומספרים בלבד.",
                    },
                    shipping_street: {
                        hasAlphanumeric: "יש להזין אותיות ומספרים בלבד.",
                    },
                    billing_street: {
                        hasAlphanumeric: "יש להזין אותיות ומספרים בלבד.",
                    },
                    billing_house_number: {
                        hasAlphanumeric: "יש להזין אותיות ומספרים בלבד.",
                    }
                },
				errorClass: 'error is-invalid',
				validClass: 'is-valid',
				errorPlacement: function (error, element) {
					var inputWrap = jQuery(element).closest('.woocommerce-input-wrapper');
					if (inputWrap.length) {
						error.insertAfter(inputWrap);
					} else {
						error.insertAfter(element);
					}
				},
				focusInvalid: false,
				invalidHandler: function (form, validator) {

					if (!validator.errorList.length > 0)
						return;

					let firstErrorEl = validator.errorList[0].element;

					if(jQuery(firstErrorEl).hasClass('pickup_location')) {
						jQuery('html, body').animate({
							scrollTop: jQuery(".checkout-shipping").offset().top
						}, 300);
					} else {
						jQuery('html, body').animate({
							scrollTop: jQuery(firstErrorEl).offset().top - 50
						}, 300, function () {
							setTimeout(() => jQuery(firstErrorEl).focus(), 350)
						});
					}
				}
			});
        }

        /**
         * Re-apply same-day delivery validation after checkout update
         * This is needed because AJAX updates recreate the input element
         */
        reapplySameDayValidation() {
            var $input = $('#same_day_delivery_city_input');
            var $form = $('#checkout');

            if (!$input.length || !$form.length) {
                return;
            }

            // Get the validator instance
            var validator = $form.data('validator');
            if (!validator) {
                this.validateCheckoutFields();
                return;
            }

            // Add rules to the new element
            $input.rules('add', {
                sameDayCityRequired: {
                    depends: function(element) {
                        var selectedMethod = $('input[name^="shipping_method"]:checked').val();
                        return selectedMethod && selectedMethod.indexOf('same_day_delivery') !== -1;
                    }
                },
                messages: {
                    sameDayCityRequired: "יש לבחור עיר מהרשימה"
                }
            });
        }

        /**
         * Greeting Text Count
         */
        greetingTextCount(e){
            var __this          = $(e.currentTarget),
                characterCount  = __this.val().length,
                current         = $('.char-count-inc');

            current.text(characterCount);
        }

        /**
         * Escape emoji, symbols, and non-Hebrew characters
         * Only allows: Hebrew letters, numbers, spaces, newlines, commas, periods
         */
        greetingTextEscChar(e) {
            var textInput = $(e.currentTarget);
            var maxChar = parseInt(textInput.attr('maxlength')) || 256;

            // Use requestAnimationFrame for iOS - ensures we get the value after emoji is inserted
            requestAnimationFrame(function() {
                var text_val = textInput.val();
                var cursorPos = textInput[0].selectionStart;

                // Filter: Only Hebrew + numbers + basic punctuation (removes emojis, symbols, English)
                // Using unicode flag 'u' for proper emoji handling
                var filtered = text_val.replace(/[^\u0590-\u05FF0-9 \n\r,.]/gu, '');

				// Collapse consecutive newlines into a single newline (no empty lines)
				filtered = filtered.replace(/(\r?\n){2,}/g, '\n');

                // Enforce max length
                if (filtered.length > maxChar) {
                    filtered = filtered.substr(0, maxChar);
                }

                if (filtered !== text_val) {
                    // Calculate new cursor position (adjust for removed characters)
                    var diff = text_val.length - filtered.length;
                    var newCursorPos = Math.max(0, cursorPos - diff);

                    textInput.val(filtered);

                    // Restore cursor position on iOS
                    try {
                        textInput[0].setSelectionRange(newCursorPos, newCursorPos);
                    } catch (err) {
                        // Some browsers may not support setSelectionRange
                    }
                }

                // Update character count
                $('.greeting-char-count .char-count-inc').text(filtered.length);
            });
        }

        /**
         * Handle paste event for greeting text - needs setTimeout to capture pasted content
         */
        greetingTextEscCharPaste(e) {
            var textInput = $(e.currentTarget);
            var maxChar = parseInt(textInput.attr('maxlength')) || 256;

            // Use setTimeout to allow paste to complete before filtering
            setTimeout(function() {
                var text_val = textInput.val();

                // Filter: Only Hebrew + numbers + basic punctuation
                // Using unicode flag 'u' for proper emoji handling
                var filtered = text_val.replace(/[^\u0590-\u05FF0-9 \n\r,.]/gu, '');

				// Collapse consecutive newlines into a single newline (no empty lines)
				filtered = filtered.replace(/(\r?\n){2,}/g, '\n');

                // Enforce max length
                if (filtered.length > maxChar) {
                    filtered = filtered.substr(0, maxChar);
                }

                textInput.val(filtered);

                // Update character count
                $('.greeting-char-count .char-count-inc').text(filtered.length);
            }, 10);
        }

        /**
         * Greeting Card Check
         */
        greetingCardCheck(e){
			// if #greetingcard-check is checked, then show the greetingcard-form
			if ($('#greetingcard-check').is(':checked')) {
				$( ".greetingcard-form" ).slideDown();
			} else {
				$( ".greetingcard-form" ).slideUp();
			}
        }

        /**
         * Handle shipping method change to hide/show fields for Local Pickup
         */
        handleShippingMethodChange() {
            const selectedShippingMethod = $('input[name^="shipping_method"]:checked').val();
            const isLocalPickup = selectedShippingMethod && selectedShippingMethod.includes('pickup');
            // Fields to hide when Local Pickup is selected
            const fieldsToHide = [
                '.woocommerce-shipping-fields',
                '#billing_city_field',
                '#billing_street_field',
                '#billing_house_number_field',
                '#billing_floor_field',
                '#billing_apartment_field'
            ];

            if (isLocalPickup) {
                // Hide all specified fields
                fieldsToHide.forEach(function(selector) {
                    $(selector).css('display', 'none');
                });
            } else {
                // Show all specified fields
                fieldsToHide.forEach(function(selector) {
                    $(selector).css('display', '');
                });
            }
        }

        /**
         * Initialize sessionStorage functionality
         */
        initSessionStorage() {
            // Only run on checkout page
            if (!$('#checkout').length) {
                return;
            }

            // Restore form data from sessionStorage
            this.restoreFormDataFromSessionStorage();

            // Clear sessionStorage on successful order completion
            $(document.body).on('checkout_error', () => {
                // Keep data on checkout error
            });

            // Clear sessionStorage when order is successfully placed
            $(document.body).on('checkout_place_order_success', () => {
                this.clearCheckoutSessionStorage();
            });
        }

        /**
         * Save form data to sessionStorage
         */
        saveFormDataToSessionStorage(e) {
            // Only run on checkout page
            if (!$('#checkout').length) {
                return;
            }

            const $element = $(e.target);
            const name = $element.attr('name');
            const type = ($element.attr('type') || '').toLowerCase();
            const isCheckbox = $element.is(':checkbox');
            const isRadio = $element.is(':radio');

            // Skip if no name attribute
            if (!name) {
                return;
            }

            // Skip certain fields that shouldn't be saved
            const skipFields = [
                'woocommerce-process-checkout-nonce',
                'woocommerce_checkout_place_order',
                'terms',
                'terms-field',
				'ship_to_different_address',
            ];

            if (skipFields.includes(name)) {
                return;
            }

            try {
                // Get existing data
                let checkoutData = JSON.parse(sessionStorage.getItem('woocommerce_checkout_data') || '{}');

                if (isCheckbox) {
                    // Persist checkbox state explicitly as '1' or '0'
                    checkoutData[name] = $element.is(':checked') ? '1' : '0';
                } else if (isRadio) {
                    // For radios, persist the selected value for the group
                    const $checked = $(`input[name="${name}"]:checked`);
                    if ($checked.length) {
                        checkoutData[name] = $checked.val();
                    } else {
                        delete checkoutData[name];
                    }
                } else {
                    const value = $element.val();
                    if (value != null && String(value).trim() !== '') {
                        checkoutData[name] = value;
                    } else {
                        // Remove empty values
                        delete checkoutData[name];
                    }
                }

                // Save back to sessionStorage
                sessionStorage.setItem('woocommerce_checkout_data', JSON.stringify(checkoutData));
            } catch (error) {
                console.warn('Error saving checkout data to sessionStorage:', error);
            }
        }

        /**
         * Restore form data from sessionStorage
         */
        restoreFormDataFromSessionStorage() {
            try {
                const checkoutData = JSON.parse(sessionStorage.getItem('woocommerce_checkout_data') || '{}');

                // Restore form field values
                Object.keys(checkoutData).forEach(fieldName => {
                    const value = checkoutData[fieldName];

                    // Handle different input types
                    const $field = $(`[name="${fieldName}"]`);

                    if ($field.length) {
                        if ($field.is(':checkbox')) {
                            // Value stored as '1' or '0'
                            const isChecked = value === '1' || value === 1 || value === true || value === 'true';
                            $field.prop('checked', isChecked);
                        } else if ($field.is(':radio')) {
                            // Select the matching radio by value
                            $field.prop('checked', false);
                            $field.filter(`[value="${value}"]`).prop('checked', true);
                        } else {
                            // For text inputs, selects, textareas
                            $field.val(value);
                        }
                    }
                });

                // Trigger change events for restored data
                Object.keys(checkoutData).forEach(fieldName => {
                    const $field = $(`[name="${fieldName}"]`);
                    if ($field.length) {
                        $field.trigger('change');
                    }
                });

            } catch (error) {
                console.warn('Error restoring checkout data from sessionStorage:', error);
            }
        }

        /**
         * Clear checkout sessionStorage data
         */
        clearCheckoutSessionStorage() {
            try {
                sessionStorage.removeItem('woocommerce_checkout_data');
            } catch (error) {
                console.warn('Error clearing checkout sessionStorage:', error);
            }
        }
    }

    // Init
    new Cart_Checkout_Manager();

	function apply_giftcard_balance(giftcard_no, balance) {

		if (balance <= 0) {
			setTimeout(() => {
				$(".coupon-message").text("המספר שהוזן שגוי או שלא קיימת יתרה בגיפט קארד");
			}, 200)
			return false;
		}

		$(".gift-redemption-box .redeem-balance-info .amount-info").text("₪" + balance);
		$(".gift-redemption-box .redeem-amount-form input[type='number']").attr('max', balance);
		$(".gift-redemption-box .redeem-amount-form .giftcard_no").val(giftcard_no);
		$(".gift-redemption-box").show();
	}

	$(document).on("click", ".gift-redemption-box .redeem-button", function (e) {
		e.preventDefault();
		if (typeof wc_checkout_params === 'undefined') {
			return;
		}
		let $button = $(this)
		let amount_to_use = $button.closest(".gift-redemption-box").find(" .redeem-amount-form input[type='number']").val()
		let giftcard_no = $button.closest(".gift-redemption-box").find(".redeem-amount-form .giftcard_no").val()
		$button.addClass('ajax_loading');

		$.ajax({
			type: 'POST',
			url: wc_checkout_params.ajax_url,
			data: {
				amount_to_use,
				giftcard_no,
				action: 'pandora-apply-giftcard',
			},
			success: function (response) {
				$button.removeClass('ajax_loading');
				if (response.success) {
					$('body').trigger('update_checkout');
				} else {
					alert(response.data)
				}
			}
		})
	})

	$(document).on("click", ".matat-remove-nayax-giftcard", function() {
		if (typeof wc_checkout_params === 'undefined') {
			return;
		}
		let giftcard_no = $(this).attr("data-giftcard-no");
		$.ajax({
			type: 'POST',
			url: wc_checkout_params.ajax_url,
			data: {
				action: 'pandora-remove-giftcard',
				giftcard_no,
			},
			success: function (response) {
				if (response.success) {
					$('body').trigger('update_checkout');
				}
			}
		})
	})

	jQuery(document.body).on('input', '.redeem-amount-form input[type="number"]', function() {
		const $form   = jQuery(this).closest('.redeem-amount-form');
		const valid   = this.checkValidity();
		$form.find('button').prop('disabled', !valid);
	});

	jQuery(document.body).on('updated_checkout', function() {
		jQuery('.redeem-amount-form').each(function(){
			const $input  = jQuery(this).find('input[type="number"]')[0];
			const valid   = $input && $input.checkValidity();
			jQuery(this).find('button').prop('disabled', !valid);
		});
	});

});
